let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7t5Ax")).then(() => parcelRequire('7xRSp'));